<!--
 * @Author: Wangchaoke
 * @Date: 2020-02-12 13:51:51
 * @LastEditTime: 2022-07-26 17:43:39
 * @LastEditors: Please set LastEditors
 * @Description: 用于填写用户信息表单页面
 * @FilePath: /xingmahui_front/src/views/activity/donation_active/userform.vue
 -->
<template>
  <div v-if="authstate" style="height:100%;">
    <div class="formMain" v-show="userInfoShow">
      <div class="formHeader">
        <!--返回-->
        <span @click="toBack"></span>
        <!--logo-->
        <div></div>
        <!--标题-->
        <h1>孕产妇奶粉申请</h1>
        <p style="margin:12px 0px 8px 0px;font-size:12px;line-height:1;">注：申请人信息与上传照片信息保持一致</p>
      </div>
      <div class="formBody">
        <!--白色区域-->
        <div class="formBodyWrap">
          <ul>
            <li>
              <h4 class="baseInfo">基本信息</h4>
              <dl>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" placeholder="姓名" v-model="userName">
                  </div>
                </dd>
                <dd>
                  <span>孕产状态：</span>
                  <van-radio-group v-model="radio">
                    <van-radio name="1">孕期</van-radio>
                    <van-radio name="2">产后三个月内</van-radio>
                  </van-radio-group>
                </dd>
                <dd>
                  <div class="option" @click="dateInfo()">
                    <input type="text" placeholder="选择预产期" v-model="date" readonly />
                  </div>
                  <span class="optionTitle">宝宝生日/预产期：</span>
                </dd>
              </dl>
            </li>
            <li>
              <h4 class="examineInfo">审核信息</h4>
              <dl>
                <dd>
                  <div @click="getUserId()" class="idCardImg" v-if="!IDCardPhoto">点击上传</div>
                  <div v-else-if="IDCardPhoto" class="idCardImgelseWrap">
                    <div class="idCardImgelse">
                      <img :src="IDCardPhotoserve" style="width:100%;height:100%;">
                    </div>
                    <div class="resetButton" @click.stop="resetChange(true)">重新上传</div>
                  </div>
                  <span class="idCardImgTitle">上传身份证正面照片</span>
                </dd>
                <dd>
                  <div @click="getBirthProof()" class="idCardImg" v-if="!BirthProof">点击上传</div>
                  <div v-else-if="BirthProof" class="idCardImgelseWrap">
                    <div class="idCardImgelse">
                      <img :src="BirthProofserve" style="width:100%;height:100%;">
                    </div>
                    <div class="resetButton" @click.stop="resetChange(false)">重新上传</div>
                  </div>
                  <span class="bornTitle">上传出生证明<br />
                    /孕检证明</span>
                </dd>
                <dd>
                  <div class="idCardNumber">
                    <input type="text" @blur="inputBlur" placeholder="请填写" v-model="cardNum">
                  </div>
                  <span>出生证明编号<br />
                    /孕检证明编号</span>
                </dd>
              </dl>
            </li>
            <li>
              <h4 class="addressInfo">地址信息</h4>
              <dl>
                <dd>
                  <div class="optionInput" @click="areaInfo()">
                    <input type="text" placeholder="小区所在区域" v-model="areaModel" readonly />
                  </div>
                </dd>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" placeholder="详细地址" v-model="rqname">
                  </div>
                </dd>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" placeholder="楼号/门牌号" v-model="doorNumber">
                  </div>
                </dd>
              </dl>
            </li>
            <li style="padding-bottom:40px;">
              <h4 class="contactInfo">联系方式</h4>
              <dl>
                <dd>
                  <div class="input">
                    <input type="number" pattern="\d*" @blur="inputBlur" placeholder="手机号" :readonly="mobilestate ? false : 'readonly'" maxlength="11" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model="mobile">
                  </div>
                  <div v-show="mobilestate">
                    <div class="input codeInput">
                      <input type="text" @blur="inputBlur" placeholder="验证码" v-model="mobileCode">
                    </div>
                    <div class="sendCode" @click="sendCode" v-show="!getCodeShow">发送验证码</div>
                    <div class="sendCode" v-show="getCodeShow">
                      <van-count-down ref="countDown" millisecond :time="60000" :auto-start="false" format="ss" @finish="countFinished" />秒后再次发送
                    </div>
                  </div>
                </dd>
              </dl>
            </li>
          </ul>
          <div class="formFooter">
            <p @click="UserSubmit()">
              <a href="javascript:void(0)">提交申请</a>
            </p>
            <div>
              <van-checkbox :value="checked" @click="onChange">我已阅读 <span style="color:blue;" @click.stop="xyfun">《活动协议》 </span>，同意对个人信息进行收集和使用</van-checkbox>
            </div>
          </div>
        </div>
      </div>
      <van-datetime-picker v-if="dateShow" class="datePiker" v-model="currentDate" type="date" :min-date="min_date" :max-date="max_date" @confirm="onConfirm" @cancel="onCancle" />
      <van-area v-if="areaShow" class="areaPiker" :area-list="areaList" value="110101" @confirm="onConfirmArea" @cancel="onCancleArea" />
      <div class="bg" v-if="xystate">
        <div class="xystyle">
          <span @click="xyfun">
            <van-icon name="cross" style="margin-top:2px;" />
          </span>
          尊敬的用户您好：<br> 此次活动依赖您提供的个人信息才能得以实施。需要您在申请页面中提供您的姓名、地址、电话、身份证信息、孕检证明/宝宝出生证明等必要信息用以完成申请资质审核及后续产品的派送。除为完成本次活动必要以及国家法律相关规定外，上述信息会进行保密，不会向他方进行提供（针对您的申领渠道会同步个人信息给申领渠道对您进行服务）。
        </div>
      </div>
    </div>
    <!-- 正在提交中 -->
    <div class="submit_loading" v-show="submitLoading">
      <van-loading type="spinner" size="50px" color="#ffffff" vertical>正在提交中...</van-loading>
    </div>
    <!-- 申请结果显示 -->
    <activity-result v-show="resultShow" :resultCode="resultCode" :channelName="channelName" :pageSource="pageSource" @userAgainWrite="againWrite" @goBack="toBack"></activity-result>
    <!-- 用户协议 -->
    <user-protocol @agreeProto="agreeProtoFn" @disagreeProto="disagreeProtoFn" v-show="userProtocolShow"></user-protocol>
    <!-- 二次确认 -->
    <div class='resertBg' v-if='resetState'></div>
    <div class="resetSet" v-if='resetState'>
      <p>是否确认重新上传？</p>
      <div class='resetMenu'>
        <span @click='resetState = false'>取消</span>
        <span @click="isResetShow ? resetUserId() : resetBirthProof()">确认</span>
      </div>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, DatetimePicker, Area } from 'vant';
/**
 * getCookie 获取本地cookie插件
 */
import { getCookie, is_weixin } from '@/assets/js/common.js';
/**
 * 调起微信相册
 */
import wxJsSet from './../../../assets/js/DonatewxConfig.js'
/**
 * Api接口
 */
import API from "@/utils/axiosApi/harvardApi";
/**
 * 新增Api接口
 */
import YAPI from "@/utils/axiosApi/donationApi";
/**
* 引入用户检查结果显示组件
*/
import activityResult from "@/components/activity/donation_active/activityResult.vue";
import userProtocol from "@/components/activity/donation_active/userProtocol.vue";
import channelData from './../../../utils/mockData/channelData';
export default {
  components: {
    activityResult,
    userProtocol
  },
  data () {
    return {
      // 协议
      checked: false,
      // 最小日期
      min_date: null,
      // 最大日期
      max_date: null,
      // 用户等级
      grade_code: null,
      // 防止页面闪屏 初始化页面为空白
      authstate: false,
      // 用户的openid
      userOpenid: null,
      // 用户姓名
      userName: null,
      // 用户信息
      UserInfo: null,
      // 身份证照片
      IDCardPhoto: null,
      IDCardPhotoserve: null,
      // 手机号
      mobile: null,
      // 验证码
      mobileCode: null,
      // 手机号状态
      mobilestate: true,
      // 地址
      address: '',
      // 出生证明
      BirthProof: null,
      BirthProofserve: null,
      // 出生/产检证明 编号
      cardNum: null,
      // 当前时间
      currentDate: new Date(),
      //默认radio
      radio: '0',
      //选择时间值
      date: '',
      //选择地区值
      area: '',
      //时间显示状态
      dateShow: false,
      //地区显示状态
      areaShow: false,
      //地区显示json
      areaList: {},
      //提交地区数据
      submitArea: {
        provinceName: '',
        provinceCode: '',
        cityName: '',
        cityCode: '',
        countryName: '',
        countryCode: '',
      },
      //地区显示于表单
      areaModel: '',
      // 小区名称
      rqname: '',
      // 门牌号
      doorNumber: '',
      // 防止重复提交
      submitState: true,
      //防止身份证重复点击
      getUserIdState: true,
      //防止出生证明重复点击
      getBirthProofState: true,
      // 协议状态
      xystate: false,
      // 结果组件显示与隐藏
      userInfoShow: false,
      resultShow: false,
      // 结果code
      resultCode: null,
      // 验证码
      getCodeShow: false,
      windowTimer: null,
      // 提交中遮罩层
      submitLoading: true,
      // 渠道名称
      channelQcode: null,
      channelName: "",
      pageSource: null,
      isWeixin: null, //是微信端还是APP
      pageSourceName: null,//页面来源名称
      userProtocolShow: false,//用户协议弹窗
      //特殊市区编码处理
      speicalCode: [
        {
          name: '仙桃',
          code: '429004',
          cityCode: '429100',
          countryCode: '429104'
        },
        {
          name: '神农架林',
          code: '429021',
          cityCode: '429200',
          countryCode: '429221'
        },
        {
          name: '潜江',
          code: '429005',
          cityCode: '429300',
          countryCode: '429305'
        },
        {
          name: '天门',
          code: '429006',
          cityCode: '429400',
          countryCode: '429406'
        },
        {
          name: '石河子',
          code: '659001',
          cityCode: '659100',
          countryCode: '659101'
        },
        {
          name: '阿拉尔',
          code: '659002',
          cityCode: '659200',
          countryCode: '659202'
        },
        {
          name: '图木舒克',
          code: '659003',
          cityCode: '659300',
          countryCode: '659303'
        },
        {
          name: '五家渠',
          code: '659004',
          cityCode: '659400',
          countryCode: '659404'
        },
        {
          name: '嘉峪关',
          code: '620200',
          cityCode: '620200',
          countryCode: '620201'
        },
        {
          name: '巢湖',
          code: '340181',
          cityCode: '340900',
          countryCode: '340901'
        },
        {
          name: '中山',
          code: '442000',
          cityCode: '442000',
          countryCode: '442001'
        },
        {
          name: '三亚',
          code: '460200',
          cityCode: '460200',
          countryCode: '460201'
        },
        {
          name: '西沙群岛',
          code: '460321',
          cityCode: '460300',
          countryCode: '460321'
        },
        {
          name: '南沙群岛',
          code: '460322',
          cityCode: '460500',
          countryCode: '460522'
        },
        {
          name: '中沙群岛',
          code: '460323',
          cityCode: '460600',
          countryCode: '460623'
        },
        {
          name: '儋州',
          code: '460400',
          cityCode: '462200',
          countryCode: '462201'
        },
        {
          name: '五指山',
          code: '469001',
          cityCode: '460700',
          countryCode: '460701'
        },
        {
          name: '琼海',
          code: '469002',
          cityCode: '460800',
          countryCode: '460801'
        },
        {
          name: '文昌',
          code: '469005',
          cityCode: '460900',
          countryCode: '460901'
        },
        {
          name: '万宁',
          code: '469006',
          cityCode: '461000',
          countryCode: '461001'
        },
        {
          name: '东方',
          code: '469007',
          cityCode: '461100',
          countryCode: '461101'
        },
        {
          name: '定安',
          code: '469021',
          cityCode: '461200',
          countryCode: '461201'
        },
        {
          name: '屯昌',
          code: '469022',
          cityCode: '461300',
          countryCode: '461301'
        },
        {
          name: '澄迈',
          code: '469023',
          cityCode: '461400',
          countryCode: '461401'
        },
        {
          name: '临高',
          code: '469024',
          cityCode: '461500',
          countryCode: '461501'
        },
        {
          name: '白沙黎族',
          code: '469025',
          cityCode: '461600',
          countryCode: '461601'
        },
        {
          name: '昌江黎族',
          code: '469026',
          cityCode: '461700',
          countryCode: '461701'
        },
        {
          name: '乐东黎族',
          code: '469027',
          cityCode: '461800',
          countryCode: '461801'
        },
        {
          name: '陵水黎族',
          code: '469028',
          cityCode: '461900',
          countryCode: '461901'
        },
        {
          name: '保亭',
          code: '469029',
          cityCode: '462000',
          countryCode: '462001'
        },
        {
          name: '琼中',
          code: '469030',
          cityCode: '462100',
          countryCode: '462101'
        },
        {
          name: '济源市',
          code: '419000',
          cityCode: '419000',
          countryCode: '419001'
        }
      ],
      resetState: false,
      isResetShow: true
    }
  },
  watch: {
    radio (val) {
      this.date = "";
      if (val == 2) {
        this.min_date = new Date(2019, 10, 1);
        this.max_date = new Date();
      } else {
        this.min_date = new Date();
        this.max_date = new Date(2020, 11, 31);
      }
    }
  },
  /**
   * @description: 导航守卫，进入页面之前执行
   */
  beforeRouteEnter (to, from, next) {
    window.scrollTo(0, 0);
    next(vm => {
      if (vm.is_weixin()) {//微信中
        //if(vm.getCookie("xmh_openid")==null || vm.getCookie("xmh_openid")==""){//判断有没有openId
        if (!vm.getCookie("xmh_openid")) {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          // 有openid获取用户信息
          vm.userOpenid = vm.getCookie('xmh_openid');
          vm.checkUser();
          vm.authstate = true;
          // 每次进入页面都需要重新获取用户信息,如果有用户信息不需要重新获取
          API.goLogin({}, { openId: vm.getCookie('xmh_openid') }, res => {
            if (res.code == "200") {
              // 赋值用户信息
              if (JSON.stringify(res.data.mobile)) {
                vm.mobile = res.data.mobile;
                vm.mobilestate = false;
              }
              vm.UserInfo = res.data;
              localStorage.setItem('userInfo', JSON.stringify(res.data));
              vm.getGrowPrice(res.data.crm_id);
            }
          })
        }
      } else {
        vm.authstate = true;
        vm.checkUser();
      }
    })
  },
  mounted () {
    var shareLink = location.origin + "/donationMilk";
    if (this.$route.query.pageSource) {
      this.pageSource = this.$route.query.pageSource;

      this.channelName = channelData.channelLogoList[this.pageSource] || channelData.channelNoLogoList[this.pageSource];

      this.channelQcode = "https://image-mom.feihe.com/channelQcode/" + this.$route.query.pageSource + ".jpg";

      if (this.pageSource.indexOf("_wx") !== -1) {
        this.isWeixin = "weixin";
      }
      shareLink = location.origin + "/donationMilk?pageSource=" + this.pageSource;
    }
    var that = this;
    var shareDataParams = {
      shareLink: shareLink,
      shareDesc: '中国飞鹤累计捐赠2亿元款物。点击领取',
      shareTitle: '飞鹤直送一亿奶粉，孕妈领取专属免疫力',
      imgUrl: "https://image-mom.feihe.com/wxshare/donation.png",//必须是绝对路径
      shareSuccess: function () {
        that.$toast({
          duration: 2000,
          message: '分享成功'
        })
      }
    }
    wxJsSet.wxShare(this, shareDataParams);

    this.pageSourceName = this.channelName ? this.channelName : "星妈会";

    gio('page.set', { 'pageSource': this.pageSourceName });
    var winHeight = $(window).height();  //获取当前页面高度
    $(window).resize(function () {
      var thisHeight = $(this).height();
      if (winHeight - thisHeight > 140) {
        //键盘弹出
        $('.formFooter').css('position', 'absolute');
      } else {
        //键盘收起
        $('.formFooter').css({ 'position': 'fixed' });

      }
    })
    YAPI.region({}, res => {
      this.areaList = JSON.parse(res.data)
      const beijingCity = [];
      const beijingCounty = [];
      const tjCity = [];
      const tjCounty = [];
      const shCity = [];
      const shCounty = [];
      const cqCity = [];
      const cqCounty = [];
      const province_list = Object.keys(this.areaList.province_list);
      const city_list = Object.keys(this.areaList.city_list);
      const county_list = Object.keys(this.areaList.county_list);
      city_list.map(item => {
        if (item.includes('1101')) {
          beijingCounty.push(item)
        }
        if (item.includes('1201')) {
          tjCounty.push(item)
        }
        if (item.includes('3101')) {
          shCounty.push(item)
        }
        if (item.includes('5001') || item.includes('5002')) {
          cqCounty.push(item)
        }
      })
      province_list.map(item => {
        if (item.includes('1101')) {
          beijingCity.push(item)
        }
        if (item.includes('1201')) {
          tjCity.push(item)
        }
        if (item.includes('3101')) {
          shCity.push(item)
        }
        if (item.includes('5001')) {
          cqCity.push(item)
        }
        this.areaList.city_list['500200'] = '县';
      })
      beijingCounty.map(item => {
        this.areaList.county_list[item.toString()] = this.areaList.city_list[item.toString()]
        delete this.areaList.city_list[item.toString()]
      })
      beijingCity.map(item => {
        this.areaList.city_list[item.toString()] = this.areaList.province_list[item.toString()]
        delete this.areaList.province_list[item.toString()]
      })
      tjCounty.map(item => {
        this.areaList.county_list[item.toString()] = this.areaList.city_list[item.toString()]
        delete this.areaList.city_list[item.toString()]
      })
      tjCity.map(item => {
        this.areaList.city_list[item.toString()] = this.areaList.province_list[item.toString()]
        delete this.areaList.province_list[item.toString()]
      })
      shCounty.map(item => {
        this.areaList.county_list[item.toString()] = this.areaList.city_list[item.toString()]
        delete this.areaList.city_list[item.toString()]
      })
      shCity.map(item => {
        this.areaList.city_list[item.toString()] = this.areaList.province_list[item.toString()]
        delete this.areaList.province_list[item.toString()]
      })
      cqCounty.map(item => {
        this.areaList.county_list[item.toString()] = this.areaList.city_list[item.toString()]
        delete this.areaList.city_list[item.toString()]
      })
      cqCity.map(item => {
        this.areaList.city_list[item.toString()] = '市辖区'
        delete this.areaList.province_list[item.toString()]
      })
      this.areaList.province_list['110000'] = '北京';
      this.areaList.province_list['120000'] = '天津';
      this.areaList.province_list['310000'] = '上海';
      this.areaList.province_list['500000'] = '重庆';
      // 单独处理
      // 湖北---潜江、天门、神农架林
      // 新疆---石河子、阿拉尔、图木舒克、五架渠
      this.speicalCode.map(item => {
        delete this.areaList.city_list[item.code];
        this.areaList.city_list[item.cityCode] = item.name;
        this.areaList.county_list[item.countryCode] = item.name;
      })
    })
  },
  methods: {
    // 同意用户协议
    agreeProtoFn () {
      this.checked = true;
      this.userProtocolShow = false;
    },
    // 不同意用户协议
    disagreeProtoFn () {
      this.checked = false;
      this.userProtocolShow = false;
      this.toBack();
    },
    // 检查用户填写状态
    checkUser () {
      /**
       * code值：
       * 200 可以填写用户信息
       * 201 已提交（审核中）
       * 202 审核通过
       * 203 审核驳回（审核未通过）
       * 204 订单创建了(发货通知)
       */
      this.$http.get("/donate/check/" + this.getCookie("xmh_openid"), {}, res => {
        this.submitLoading = false;
        if (res.code == "200") {
          this.userInfoShow = true;
          this.resultShow = false;
          this.userProtocolShow = true;
        } else if (res.code == "201" || res.code == "202" || res.code == "203" || res.code == "204") {
          if (res.code == "203" && this.$route.query.isAgain) {
            this.resultShow = false;
            this.userInfoShow = true;
            this.userProtocolShow = true;
          } else {
            this.resultCode = res.code;
            this.userInfoShow = false;
            this.resultShow = true;
            this.userProtocolShow = false;
          }
        } else {
          this.userInfoShow = true;
          this.resultShow = false;
          this.userProtocolShow = true;
        }
      }, error => {
        this.submitLoading = false;
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    // 用户状态为203时，点击重新填写
    againWrite () {
      // if(new Date().getHours()<9){
      //     this.$toast({
      //         duration:4000,
      //         message:'9点限量开放，先到先得！'
      //     })
      // }else if(new Date().getHours()>=9 && new Date().getHours()<15){ //9点到下午15点
      //     this.checkCount("今日上午已达上限，信息无法提交。\n下午15点限量开放，先到先得！");
      // }else{
      //     this.checkCount("您好，申领活动已结束");
      // }
      this.$toast({
        duration: 4000,
        message: '您好，申领活动已结束'
      })
    },
    checkCount (message) {
      // 9点之后
      YAPI.countMember({}, res => {
        if (!res.data) {
          this.$toast({
            duration: 4000,
            message: message
          })
        } else {
          this.resultShow = false;
          this.userInfoShow = true;
          this.userProtocolShow = true;
          this.gioFn("donationmilk_reapply");//捐奶粉活动-重新gio埋点
        }
      }, error => {
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    // 解决输入框收回时会有空白区域的问题
    inputBlur () {
      $(window).scrollTop($(window)[0].scrollY);
    },
    // 协议
    xyfun () {
      this.xystate = !this.xystate;
    },
    // 发送验证码
    sendCode () {
      let iphonereg = /^[1]([3-9])[0-9]{9}$/
      if (this.mobile && iphonereg.test(this.mobile)) {
        // this.$http.hostName+
        this.$http.get(`${this.$http.hostName}/activity/common/sendVerificationCode`, { phone: this.mobile }, res => {
          if (res.code === "200") {
            this.getCodeShow = true;
            this.$refs.countDown.start();
            this.$toast({
              message: '发送成功',
              forbidClick: true,
              duration: 2000,
              context: this
            })
          } else {
            this.$toast({
              message: res.message,
              forbidClick: true,
              duration: 2000,
              context: this
            });
          }
        })
      } else {
        this.$toast({
          duration: 2000,
          message: '请输入正确的手机号',
          context: this
        })
      }
    },
    countFinished: function () {
      this.getCodeShow = false;
      this.$refs.countDown.reset();
    },
    // 调取相册获取用户省份证
    getUserId () {
      let that = this;
      clearTimeout(this.windowTimer)
      this.windowTimer = setTimeout(function () {
        wxJsSet.getAlbum(that, (res) => {
          that.IDCardPhoto = res[0];
          YAPI.uploadImages(res[0], {}, {}, response => {
            const { code, data } = response
            if (code === '200') {
              that.IDCardPhotoserve = data
            }
          })
        });
      }, 100)
    },
    // 调取相册获取出生证明
    getBirthProof () {
      let that = this;
      clearTimeout(this.windowTimer)
      this.windowTimer = setTimeout(function () {
        wxJsSet.getAlbum(that, (res) => {
          if (res != "err") {
            that.BirthProof = res[0];
            YAPI.uploadImages(res[0], {}, {}, response => {
              const { code, data } = response
              if (code === '200') {
                that.BirthProofserve = data
              }
            })
          }
        });
      }, 100)
    },
    // 用户提交申请
    UserSubmit () {
      this.$toast({
        duration: 4000,
        message: '您好，申领活动已结束'
      })
      // if(new Date().getHours()<9){
      //     this.$toast({
      //         duration:4000,
      //         message:'9点限量开放，先到先得！'
      //     });
      // }else if(new Date().getHours()>=9 && new Date().getHours()<15){ //9点到下午15点
      //     this.checkCountSubmit("今日上午已达上限，信息无法提交。\n下午15点限量开放，先到先得！");
      // }else{
      //     this.checkCountSubmit("您好，申领活动已结束");
      // }
    },
    checkCountSubmit (message) {
      YAPI.countMember({}, res => {
        if (!res.data) {
          this.$toast({
            duration: 4000,
            message: message
          })
        } else {
          if (this.submitState) {
            this.gioFn("donationmilk_apply");//提交申请gio埋点
            this.submitState = false;
            console.log(this.IDCardPhotoserve, this.BirthProofserve)
            if (this.userName && this.date && this.IDCardPhotoserve && this.cardNum && this.BirthProofserve && this.rqname && this.areaModel && this.doorNumber && this.mobile && this.userOpenid) {
              if (!this.mobilestate) {//老用户不用填写验证码
                this.submitFn("");
              } else {//新用户输入验证码
                if (this.mobileCode) {
                  this.submitFn(this.mobileCode);
                } else {
                  this.submitState = true;
                  this.$toast({
                    duration: 2000,
                    message: '有信息未填写',
                    context: this
                  })
                }
              }
            } else {
              this.submitState = true;
              this.$toast({
                duration: 2000,
                message: '有信息未填写',
                context: this
              })
            }
          }
        }
      }, error => {
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    submitFn (mobileCode) {
      var that = this;
      const submitJson = {
        address: this.doorNumber,
        antenatalExaminationPicUrl: this.BirthProofserve,
        cardNum: this.cardNum,
        cityCode: this.submitArea.cityCode,
        cityName: this.submitArea.cityName,
        districtCode: this.submitArea.countryCode,
        districtName: this.submitArea.countryName,
        idCardFrontUrl: this.IDCardPhotoserve,
        memberMobile: this.mobile,
        memberName: this.userName,
        openId: this.userOpenid,
        pregnant: this.radio,
        provinceCode: this.submitArea.provinceCode,
        provinceName: this.submitArea.provinceName,
        street: this.rqname,
        babyBirth: this.date,
        grade_code: this.grade_code,
        code: mobileCode
      }
      let iphonereg = /^[1]([3-9])[0-9]{9}$/
      if (iphonereg.test(this.mobile)) {
        if (this.checked) {
          this.submitLoading = true;
          // 防止重复提交
          var channelName = this.channelName ? this.channelName : "星妈会";
          YAPI.UserSubmit({ channel: channelName }, submitJson, res => {
            this.submitLoading = false;
            this.submitState = true;
            // 防止重复提交
            if (res.code == "500") {
              this.$toast({
                duration: 2000,
                message: res.message,
                context: this
              });
            } else {
              if (res.code == "200") {
                this.resultCode = "true";
                this.userInfoShow = false;
                this.resultShow = true;
                this.gioFn("donationmilk_successfulapply");//捐奶粉活动-申请成功gio埋点
              } else {
                this.$toast({
                  duration: 2000,
                  message: res.message,
                  context: this,
                  onClose: function () {
                    that.checkUser();
                  }
                })
              }
            }
          }, error => {
            this.submitLoading = false;
            this.$toast({
              duration: 2000,
              message: '活动太火爆了，请稍后重试。'
            })
          })
        } else {
          this.submitState = true;
          this.$toast({
            duration: 2000,
            message: '同意活动协议后才可提交',
            context: this
          })
        }

      } else {
        this.submitState = true;
        this.$toast({
          duration: 2000,
          message: '请检查手机号格式是否正确',
          context: this
        })
      }
    },
    // 获取用户等级
    getGrowPrice (crmId) {
      this.$http.post('/rights/growPrice', {}, { crmId: crmId }, res => {
        this.grade_code = res.data.grade.code;//初始化用户等级
      },err =>{}, "member")
    },
    // 用户协议状态
    onChange () {
      this.checked = !this.checked;
    },
    //显示时间
    formatDate (date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    //时间选择--确认
    onConfirm (date) {
      this.dateShow = false;
      this.date = this.formatDate(date);
    },
    //时间选择--取消
    onCancle () {
      this.dateShow = false;
    },
    //地区选择--确认
    onConfirmArea (area) {
      this.areaShow = false;
      this.submitArea.provinceName = area[0].name;//省
      this.areaList.province_list['110000'] = '北京';
      this.areaList.province_list['120000'] = '天津';
      this.areaList.province_list['310000'] = '上海';
      this.areaList.province_list['500000'] = '重庆';
      switch (area[0].code) {
        case '110000':
          this.submitArea.provinceCode = '110100';//省code
          break;
        case '120000':
          this.submitArea.provinceCode = '120100';//省code
          break;
        case '310000':
          this.submitArea.provinceCode = '310100';//省code
          break;
        case '500000':
          this.submitArea.provinceCode = '500100';//省code
          break;
        default:
          this.submitArea.provinceCode = area[0].code
          break;
      }
      this.submitArea.cityName = area[1].name;//市
      this.submitArea.countryName = area[2].name;
      const specialArr = [];
      this.speicalCode.map(item => {
        specialArr.push(item.name);
      })
      if (specialArr.includes(area[2].name)) {
        specialArr.map((val, i) => {
          if (val === area[2].name) {
            this.submitArea.cityCode = this.speicalCode[i].code;//市code
            this.submitArea.countryCode = this.speicalCode[i].code;//区code
          }
        })
      } else {
        this.submitArea.cityCode = area[1].code;//市code
        this.submitArea.countryCode = area[2].code;//区code
      }
      this.areaModel = `${area[0].name}/${area[1].name}/${area[2].name}`
      const newArr = new Set(this.areaModel.split('/'))
      this.areaModel = [...newArr].join('');
    },
    //地区选择--取消
    onCancleArea () {
      this.areaShow = false;
    },
    //时间状态
    dateInfo () {
      if (this.radio == "0") {
        this.$toast({
          duration: 2000,
          message: '请先选择孕产状态',
          context: this
        })
      } else {
        this.dateShow = true;
      }
    },
    //地区状态
    areaInfo () {
      this.areaShow = true;
    },
    resetUserId () {
      this.IDCardPhoto = null;
      this.IDCardPhotoserve = null;
      this.resetState = false;
    },
    resetBirthProof () {
      this.BirthProof = null;
      this.BirthProofserve = null;
      this.resetState = false;
    },
    resetChange (isShow) {
      this.isResetShow = isShow;
      this.resetState = true;
    },
    // 返回上一页
    toBack () {
      if (this.pageSource) {
        location.href = "/donationMilk?pageSource=" + this.pageSource;
      } else {
        location.href = "/donationMilk";
      }
    },
    // gio埋点
    gioFn (fnName) {
      gio('track', fnName, { "pageSource_var": this.pageSourceName, "isWeixin": this.isWeixin });
    },
    getCookie, is_weixin
  },

}
</script>

<style lang="less" scoped>
dd {
  cursor: pointer;
}
.bg {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.xystyle {
  width: 334px;
  height: 317px;
  box-sizing: border-box;
  padding: 45px 30px 40px 30px;
  background-color: #fff;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 20px;
  line-height: 23px;
  font-size: 14px;
  span {
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    right: 30px;
    top: -45px;
    border: 1px solid #fff;
    color: #fff;
    text-align: center;
    line-break: 20px;
    font-size: 20px;
    font-weight: bold;
  }
}
.formMain {
  width: 100%;
  position: relative;
  overflow: hidden;
}
// 正在提交中
.submit_loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9999;
  .van-loading {
    width: 140px;
    height: 150px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #ffffff;
  }
  .van-loading__text {
    font-size: 18px;
    color: #ffffff;
  }
}

.formHeader {
  width: 100%;
  height: 207px;
  background: url(../../../assets/images/activity/donationActive/form_bg.jpg)
    no-repeat left top #feeb2d;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 39px;
  padding-left: 23px;
  span {
    width: 12px;
    height: 23px;
    background: url(../../../assets/images/activity/donationActive/form_arr_l.png)
      no-repeat left center;
    background-size: 100% 100%;
    display: block;
    margin-bottom: 25px;
  }
  div {
    width: 124px;
    height: 25px;
    background: url(../../../assets/images/activity/donationActive/form_logos.png)
      no-repeat center center;
    background-size: 100% auto;
    margin-bottom: 30px;
    margin-left: 18px;
  }
  h1 {
    font-size: 22px;
    line-height: 1;
    color: #073190;
  }
}
.formBody {
  background: #feeb2d;
  .formBodyWrap {
    margin: 0 20px;
    border-radius: 30px 30px 0 0;
    background: #fff;
    padding: 22px 20px 40px 20px;
    ul {
      li {
        margin-bottom: 38px;
        h4 {
          margin-left: 6px;
          line-height: 22px;
          font-size: 18px;
          color: #073190;
          padding-left: 28px;
          margin-bottom: 22px;
          &.baseInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon1.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.examineInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon2.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.addressInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon3.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.contactInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon4.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
        }
        .input {
          width: 100%;
          height: 51px;
          border: 1px solid #b5b5b5;
          border-radius: 10px;
          overflow: hidden;
          padding: 0 20px;
          box-sizing: border-box;
          input {
            border: 0;
            width: 100%;
            font-size: 17px;
            color: #999999;
            padding: 13px 0;
          }
        }
        .codeInput {
          width: 165px;
          margin-top: 13px;
          float: left;
        }
        .sendCode {
          width: 113px;
          height: 51px;
          background: linear-gradient(
            90deg,
            rgba(255, 236, 57, 1) 0%,
            rgba(255, 231, 0, 1) 100%
          );
          border-radius: 10px;
          float: right;
          margin-top: 13px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(153, 153, 153, 1);
          line-height: 51px;
          text-align: center;
          .van-count-down {
            color: @expertFontColor153;
            font-size: @indexFontSize14;
            margin-top: 1px;
            height: 51px;
            line-height: 51px;
            display: inline-block;
          }
        }
        .optionInput {
          width: 100%;
          height: 51px;
          border: 1px solid #b5b5b5;
          border-radius: 10px;
          overflow: hidden;
          padding: 0 35px 0 20px;
          box-sizing: border-box;
          background: url(../../../assets/images/activity/donationActive/form_arr_d.png)
            no-repeat 260px center;
          background-size: 16px 10px;
          input {
            border: 0;
            width: 100%;
            line-height: 50px;
            font-size: 17px;
            color: #999999;
          }
        }
        dd {
          clear: both;
          margin-bottom: 24px;
          span {
            font-size: 15px;
            color: #333333;
            font-weight: bold;
            float: left;
            &.idCardImgTitle {
              line-height: 58px;
            }
            &.bornTitle {
              padding-top: 10px;
            }
          }
          .van-radio-group {
            float: right;
            .van-radio {
              float: left;
              font-size: 14px;
              color: #333333;
              line-height: 24px;
              font-weight: bold;
              margin-left: 10px;
            }
          }
          .optionTitle {
            line-height: 34px;
          }
          .option {
            width: 140px;
            height: 34px;
            line-height: 34px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #b5b5b5;
            padding: 0 25px 0 10px;
            box-sizing: border-box;
            float: right;
            background: url(../../../assets/images/activity/donationActive/form_arr_d.png)
              no-repeat 114px center;
            background-size: 16px 10px;
            input {
              border: 0;
              width: 100%;
              line-height: 34px;
              font-size: 17px;
              color: #999999;
            }
          }
          .idCardImg {
            float: right;
            width: 97px;
            height: 59px;
            background: #f2f2f2;
            border-radius: 3px;
            font-size: 14px;
            color: #999999;
            padding-top: 10px;
            box-sizing: border-box;
            text-align: center;
            &:before {
              display: block;
              width: 20px;
              height: 16px;
              margin: 0 auto 6px;
              content: '';
              background: url(../../../assets/images/activity/donationActive/form_icon7.png)
                no-repeat center top;
              background-size: 20px 16px;
            }
          }
          .idCardImgelseWrap {
            float: right;
            width: 97px;
            padding-top: 10px;
            text-align: center;
          }
          .idCardImgelse {
            width: 97px;
            min-height: 97px;
            height: auto;
            img {
              width: 100%;
              height: auto;
            }
          }
          .resetButton {
            display: inline-block;
            margin-top: 6px;
            color: #073190;
            padding-right: 16px;
            line-height: 18px;
            background: url(../../../assets/images/activity/donationActive/icon_reset.png)
              no-repeat right center;
            background-size: auto 12px;
            text-align: center;
          }
          .idCardNumber {
            float: right;
            width: 163px;
            height: 32px;
            border: 1px solid #b5b5b5;
            border-radius: 4px;
            overflow: hidden;
            padding: 0 9px;
            box-sizing: border-box;
            input {
              border: 0;
              width: 100%;
              font-size: 14px;
              color: #999999;
              padding: 6px 0;
            }
          }
          &:after {
            clear: both;
            content: '';
            width: 100%;
            display: block;
            height: 1px;
            font-size: 1px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.formFooter {
  width: 100%;
  height: 100px;
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 0px 40px 13px 40px;
  box-sizing: border-box;
  p {
    color: #fff;
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(
      -90deg,
      rgba(32, 61, 171, 1),
      rgba(39, 76, 213, 1)
    );
    font-size: 20px;
    line-height: 50px;
    margin: 0 auto;
  }
  div {
    width: 120%;
    padding-top: 17px;
    font-size: 12px;
    transform: scale(0.92);
    -webkit-transform: scale(0.92); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scale(0.92); /*兼容-moz-引擎浏览器*/
    margin-top: -10px;
    margin-left: -12px;
  }
}
.datePiker,
.areaPiker {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.resertBg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
}
.resetSet {
  width: 270px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  z-index: 201;
  p {
    text-align: center;
    padding: 24px 0;
    line-height: 2em;
    font-size: 16px;
  }
  .resetMenu {
    border-top: 1px solid rgba(229, 229, 229, 1);
    height: 40px;
    span {
      width: 135px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      float: left;
      text-align: center;
      font-size: 16px;
      color: #333;
      &:last-child {
        width: 134px;
        border-left: 1px solid rgba(229, 229, 229, 1);
        color: #004097;
      }
    }
  }
}
</style>
